import { App } from "antd";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { addFeedback } from "store/bailiff/draft/dialog/draft_dialog.action";
import { draftDialogCommentsSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
import { emailSelector } from "store/user/auth/user_auth.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useActionDraftComment = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const comments = useSelector(draftDialogCommentsSelector);
  const email = useSelector(emailSelector);

  // -------------------------- FUNCTION ------------------------
  const handleAddFeedback = ({ id, feedback, setHideCom = () => {} }) => {
    console.log({ id, comments, feedback, email });
    if (!comments || !id || !feedback || !email) {
      return message.error("Data not found!");
    }

    dispatch(
      addFeedback({ data: comments, id, feedback, feedbackName: email }),
    );
    setHideCom(false);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { handleAddFeedback };
};
